import React, {useEffect, useState} from "react";
import {Select} from "antd";
import {shippersService} from "../../../../../../../services/shippers/shippers.services";
import {ShippingCourier} from "../../../../../../../models/shipping/shipping";
import {WidgetProps} from "../../widget";

export const UiInputShippingCouriers: React.FC<WidgetProps> = ({value, onChange, multiple, loading}) => {

    const [couriers, setCouriers] = useState<ShippingCourier[]>([]);

    useEffect(() => {
        shippersService.getCouriers().then(couriers => setCouriers(couriers));
    }, [])

    return (
        <Select
            mode={multiple ? "multiple" : undefined}
            onChange={onChange as any}
            value={value as any}
            allowClear={true}
            showSearch
            optionFilterProp={"children"}
            disabled={loading}
        >
            {couriers.map(department => (
                <Select.Option value={department.id}>{department.name} ({department.warehouses.length > 0 ? (department.warehouses.map(w => w.name).join(', ')) : 'ALL'})</Select.Option>
            ))}
        </Select>
    )
}